<template>
  <div v-if="article">
    <div
      v-if="article.cover"
      id="banner"
      class="uk-height-small uk-flex uk-flex-center uk-flex-middle uk-background-cover uk-light uk-padding"
      :data-src="api_url + article.cover.url"
      uk-img
    >
      <h1>{{ article.title }}</h1>
    </div>
    <ul class="uk-breadcrumb" v-if="article.category">
        <li class="uk-disabled"><a>{{ article.category.class.name }}</a></li>
        <li><span>{{ article.category.name }}</span></li>
    </ul>
    <div class="uk-section">
      <div class="uk-container uk-container-small">
        <div v-html="compileMarkdown(article.content)"></div>
        <!-- <vue-markdown-it
          v-if="article.content"
          :source="article.content"
          id="editor"
          :options="options"
        /> -->
        <!-- <p v-if="article.published_at">
          {{ moment(article.published_at).format("MMM Do YY") }}
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
// import VueMarkdownIt from "vue-markdown-it";
import gql from "graphql-tag";

const marked = require("marked")
marked.setOptions({
  baseUrl: process.env.VUE_APP_STRAPI_API_URL
})


export default {
  data() {
    return {
      articulos: null,
      moment: moment,
      api_url: process.env.VUE_APP_STRAPI_API_URL,
      routeParam: this.$route.params.id,
      options: {
        markdownIt: {
          linkify: true
        },
        linkAttributes: {
          attrs: {
            target: '_blank',
            rel: 'noopener'
          }
        }
      }
    };
  },
  // components: {
  //   VueMarkdownIt
  // },
  methods:{
    ifImage(ext) {
      return ['.jpg', '.png', '.jpeg', '.gif'].includes(ext.toUpperCase())
    },
    compileMarkdown(input){
      return marked(input, {sanitize: true}) 
    }
  },
  computed: {
    article(){
      // console.log("Articulos", this.articulos.length)
      return this.articulos?.length>0 ? this.articulos[0] : null
    }
  },
  apollo: {
    articulos: {
      query: gql`
        query($slug: String!){
          articulos: pages(where:{
            slug: $slug
          }){
            title
            slug
            content
            category{
              name
              class{
                name
              }
            }
            cover{
              url
            }
          }
        }
      `,
      variables() {
        return {
          slug: this.routeParam
        };
      }
    }
  }
};
</script>